import styles from "../style";
import { Reveal } from "./reveal";
import { LogoIcon } from "../assets";

const Provide = () =>  {
  return (
  <div className={`w-full justify-center items-center flex flex-col gap-6 pb-20 px-10`}>
    <div className="flex flex-row gap-4 items-center pt-40 pb-16">
      <span className="border-b border-1 border-second xs:w-[200px] w-[150px]"></span>
      <img
        src={LogoIcon}
        alt="HSL"
        className="w-[50px] h-[50px] object-contain"
      />
      <span className="border-b border-1 border-second xs:w-[200px] w-[150px]"></span>
    </div>

    <div className="flex flex-col gap-4 items-start md:items-center">
      <div className="flex flex-col items-start md:items-center">
        <Reveal>
          <h2 className="kerning-normal xs:pt-6 xs:text-md text-md text-white font-semibold">
            What We Provide:
          </h2>
        </Reveal>
        <span className="xs:mb-6 border-b border-2 border-second w-[100px]"></span>
      </div>
      <Reveal>
        <div className={`pt-10 pb-14 flex flex-col md:flex-row md:gap-20 md:items-center items-start justify-center`}>
          <p className={`kerning-normal xs:text-sm text-ss text-start text-tertiary my-2 xs:w-[400px] md:w-[240px]`}>
            <p className="kerning-normal font-semibold xs:text-mm text-sm text-second py-2">Financing</p>Patient, flexiblecapital to scale
          </p> 
          <p className={`kerning-normal xs:text-sm text-ss text-start text-tertiary my-2 xs:w-[400px] md:w-[240px]`}>
            <p className="kerning-normal font-semibold xs:text-mm text-sm text-second py-2">Tech Support</p>In-house/affiliate help for robust, scalable solutions
          </p> 
          <p className={`kerning-normal xs:text-sm text-ss text-start text-tertiary my-2 xs:w-[400px] md:w-[240px]`}>
            <p className="kerning-normal font-semibold xs:text-mm text-sm text-second py-2">Business & Advisory</p>Strategy, networking, mentorship, legal, financial admin
          </p>
        </div>        
      </Reveal>
    </div> 
  </div>
)};

export default Provide;